import { useMemo } from 'react';
import { toUpperCase } from '../helpers/toUpperCase';
import { soundTypes } from '../services/SoundService';
import { gameStore } from '../store/gameStore';

function useSoundsByName() {
  const { gameTypes } = gameStore;
  return useMemo(() => {
    const roomNames = gameTypes.map((game) => game.name);

    return Object.fromEntries(
      roomNames.map((name, index) => [toUpperCase(name), soundTypes[`contest${index + 1}`]])
    );
  }, [gameTypes]);
}

export default useSoundsByName;
